import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireInstantpage } from "/home/runner/work/Municipio/Municipio/node_modules/instant.page/instantpage.js";
var instantpageExports = requireInstantpage();
export { instantpageExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(instantpageExports);